/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useState } from 'react'
import { Table, Divider, Row, Col, Button, Modal, Select, DatePicker } from 'antd'
import styles from './index.less'
import moment from 'moment'
import { RESERVE_STATUS_ENUM } from '@/utils/consts'

const { Option } = Select

const LogisticsInfo = ({ data,reserveStatus,pagination,onChange }) => {

  const columns = [
    {
      dataIndex: 'deliveryDate',
      title: '发货日期',
      width: 140,
      render(text) {
        return moment(text).format('YYYY-MM-DD')
      }
    },
    {
      dataIndex: 'expressCompany',
      title: '快递公司',
      width: 180,
    },

    {
      dataIndex: 'expressNumber',
      title: '快递单号',
      width: 160,
    },
    {
      dataIndex: 'deliveryConfirmer',
      title: '发货确认人',
      width: 140,
    },
    {
      dataIndex: 'status',
      title: '状态',
      width: 80,
    },
    {
      dataIndex: 'comment',
      title: '备注',
      width: 80,
    },
    {
      dataIndex: 'operation',
      title: '操作',
      width: 140,
      align: 'center',
      render(text, record) {
        return <Fragment>
          <a href="javascript:void(0);" disabled={record.status === 'cancel'} onClick={() => onEdit('update', record)}>编辑</a>
        </Fragment>
      }
    }
  ]

  return (
    <div className={styles.reserve}>
      <Table
        columns={columns}
        dataSource={data}
        pagination={{
          ...pagination,
          onChange
        }}
        defaultExpandAllRows={true}
        size="small"
        rowKey="id"
      />
    </div>
  )
}

export default LogisticsInfo